import React, { Suspense, lazy, useEffect, useState } from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
const HelmetWrapper = React.lazy(() => import('./seo/HelmetWrapper'));
const AppRoutes = React.lazy(() => import('./AppRoutes'));
import './App.css';
const Analytics = lazy(() => import('./seo/Analytics'));

function App() {
  const [loadAnalytics, setLoadAnalytics] = useState(false);

  // Load Google Analytics lazily (kept as idle/fallback)
  useEffect(() => {
    if ('requestIdleCallback' in window) {
      // @ts-ignore
      requestIdleCallback(() => setLoadAnalytics(true));
    } else {
      setTimeout(() => setLoadAnalytics(true), 1500);
    }
  }, []);

  return (
    <ThemeProvider>
      <React.Suspense fallback={null}>
        <HelmetWrapper>
          <Suspense fallback={<div />}> 
            <AppRoutes />
          </Suspense>
          {loadAnalytics && (
            <Suspense fallback={null}>
              <Analytics />
            </Suspense>
          )}
        </HelmetWrapper>
      </React.Suspense>
    </ThemeProvider>
  );
}

export default App;